// extracted by mini-css-extract-plugin
module.exports = {"visually-hidden":"VideoItem_visually-hidden__vXf1L","container":"VideoItem_container__qv_Ka","base-content":"VideoItem_base-content__q7VF2","root":"VideoItem_root__YmGyY"};